import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import api from '../../../config/axiosConfig';

function BookingDetails() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [bookingDetails, setBookingDetails] = useState({
    accountId: '',
    programId: searchParams.get("programId"),
    residenceId: searchParams.get("roomId"),
    checkInDate: searchParams.get("startDate"),
    checkOutDate: searchParams.get("endDate"),
    days: searchParams.get("duration"),
    extraPerson: searchParams.get("extraPerson"),
    totalPrice: searchParams.get("totalBill"),
  });

  const [formData, setFormData] = useState({
    name: '',
    stateId: '',
    countryId: '',
    idProofTypeId: '',
    idProofNumber: '',
    idProofDocument: '',
    address: '',
    isOrganization: '',
    GST: '',
    isactive: true,
    email: '',
    phone: ''
  });

  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleAddData = async (e) => {
    e.preventDefault();
    if (formData.name) {
      try {
        const url = isEditMode ? `/accounts/${formData.id}` : '/accounts';
        const method = isEditMode ? 'put' : 'post';
        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('stateId', formData.stateId);
        formDataToSend.append('countryId', formData.countryId);
        formDataToSend.append('idProofTypeId', formData.idProofTypeId);
        formDataToSend.append('idProofNumber', formData.idProofNumber);
        formDataToSend.append('address', formData.address);
        formDataToSend.append('isOrganization', formData.isOrganization);
        formDataToSend.append('GST', formData.GST);
        formDataToSend.append('isactive', formData.isactive);
        if (file) formDataToSend.append('idProofDocument', file);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('phone', formData.phone);

        const response = await api({
          method,
          url,
          data: formDataToSend,
        });

        if (response.status === 201) {
          setBookingDetails(prevState => ({
            ...prevState,
            accountId: response.data
          }));
        }
      } catch (error) {
        console.error('Error:', error);
      }

      setFormData({
        id: null,
        name: '',
        isactive: true,
        stateId: '',
        countryId: '',
        idProofTypeId: '',
        idProofNumber: '',
        idProofDocument: '',
        address: '',
        isOrganization: '',
        GST: '',
        email: '',
        phone: ''
      });
      setIsEditMode(false);
    } else {
      alert("Please fill out the name field.");
    }
  };

  useEffect(() => {
    if (bookingDetails.accountId) {
      const createBooking = async () => {
        try {
          const response2 = await api({
            method: 'POST',
            url: '/bookings',
            data: bookingDetails,
          });
        } catch (error) {
          console.error('Error creating booking:', error);
        }
      };
      createBooking();
    }
  }, [bookingDetails.accountId]);

  return (
    <>
      <div className="bookingpage">
        <Container className='row mx-auto'>
        <h4 className="text-start pageheader pb-3">{isEditMode ? "Edit Account" : "Add Account"}</h4>
          <div className='col-md-8 bookingpagebox'>
            <Row className="mt-4 p-4">
              <Col md={12}>
                <Form onSubmit={handleAddData} className="bookingform p-md-5 p-3">
                  <Row>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="me-3">Name:</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Enter name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          className="border-0 rounded-0 py-2 form-box"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mt-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Email:</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="email"
                            name="email"
                            placeholder="Enter Email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="border-0 rounded-0 py-2 form-box"
                          />
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Phone:</Form.Label>
                        <InputGroup>
                          <Form.Control
                            type="number"
                            name="phone"
                            placeholder="Enter Phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            className="border-0 rounded-0 py-2 form-box"
                          />
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Button variant="primary" type="submit" className="mt-4">
                    Add
                  </Button>
                </Form>
              </Col>
            </Row>
          </div>
          <div className="col-md-4 pt-5 ">
          <div className="total-pricediv p-md-5 p-3">        
                      <p><b>Program ID:</b> {bookingDetails.programId}</p>
                      <p><b>Room ID:</b> {bookingDetails.residenceId}</p>
                      <p><b>Check-In:</b> {bookingDetails.checkInDate}</p>
                      <p><b>Check-Out:</b> {bookingDetails.checkOutDate}</p>
                      <p><b>Total Bill:</b> {bookingDetails.totalPrice}</p>
                  </div>
          </div>
        </Container>
      </div>
    </>
  );
}

export default BookingDetails;
